import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-105bf21c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "创建时间：", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单状态：", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"60px"} }, "订单号：", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 8,
  class: "action_btn_box"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("订单详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_check_outlined = _resolveComponent("check-outlined")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "订单列表",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          align: "middle",
          type: "flex",
          gutter: 16
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_a_range_picker, {
                  value: _ctx.searches.dateTime,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.dateTime) = $event)),
                  style: {"width":"300px"},
                  format: "YYYY-MM-DD",
                  onChange: _ctx.onDateChange
                }, null, 8, ["value", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_select, {
                  value: _ctx.searches.type,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.type) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch('type', $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logisticsOrderStatus, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: `${item.id}`,
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider),
        _createVNode(_component_a_row, {
          align: "middle",
          type: "flex",
          gutter: 16
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_a_input_search, {
                    value: _ctx.searches.keyword,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searches.keyword) = $event)),
                    "enter-button": "",
                    onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onInputSearch('order_sn', $event))),
                    placeholder: "订单号搜索"
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { style: {"flex":"1"} }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "dashed",
                  onClick: _ctx.resetSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'shipper_user' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(text.nickname) + " ", 1),
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(text.mobile), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'receiver_user' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(text ? text.name : '未接单'), 1),
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(text ? text.phone : ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'shipper' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(text.name) + "," + _toDisplayString(text.phone), 1),
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(text.province_name) + _toDisplayString(text.city_name) + _toDisplayString(text.county_name) + _toDisplayString(text.address), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'receiver' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(text.name) + "," + _toDisplayString(text.phone), 1),
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(text.province_name) + _toDisplayString(text.city_name) + _toDisplayString(text.county_name) + _toDisplayString(text.address), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'goods' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(text.goods_category_name) + "，数量：" + _toDisplayString(text.number), 1),
              _hoisted_11,
              _createTextVNode(" 重量：" + _toDisplayString(text.weight) + "kg，体积：" + _toDisplayString(text.volume) + "立方 ", 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'car' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createTextVNode(_toDisplayString(text ? text.plate_number : '未接单'), 1),
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(text ? text.car_type : ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 6,
              color: _ctx.getLogisticsOrderStatus(text)?.color
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getLogisticsOrderStatus(text)?.name), 1)
              ]),
              _: 2
            }, 1032, ["color"]))
          : _createCommentVNode("", true),
        (column.key === 'sort' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              (_ctx.editItem?.id === record.id)
                ? (_openBlock(), _createBlock(_component_a_input_search, {
                    key: 0,
                    defaultValue: text,
                    onSearch: _ctx.onSort
                  }, {
                    enterButton: _withCtx(() => [
                      _createVNode(_component_a_button, null, {
                        icon: _withCtx(() => [
                          _createVNode(_component_check_outlined)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["defaultValue", "onSearch"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(text), 1))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_a_button, {
                class: "action_btn",
                size: "small",
                type: "primary",
                onClick: ($event: any) => (_ctx.goDetail(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}